import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector';
import { getProductAmount } from 'root/src/shared/util/getProductAmount';
export const projectProductAmountSelector = (state, props) => {
    const project = getRecordSelector(state, props);
    if (!project) {
        return 0;
    }
    const { brandProduct } = project;
    return getProductAmount(brandProduct);
};
